import { SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../redux/reducers/rootReducer';
import { IMainPage } from '../../utils/types/state-types';
import CareerCard from '../CareerCard';
import Slider from '../UI/Slider';
import classes from './career-block.module.scss';

interface ICareerBlockProps {
  title: string;
}

interface ICard {
  id: string;
  title: string;
  subtitle: string;
  image?: string;
}

function CareerBlock({ title }: ICareerBlockProps) {
  const mainPage = useSelector<RootState, IMainPage | null>(
    (state) => state.mainReducer.mainPage,
  );

  return mainPage?.scrollCardsShow ? (
    <div className={classes.companyContainer}>
      <Slider title={title} isColored={false}>
        <SplideTrack>
          {mainPage?.scrollCards.map((card: ICard, idx) => (
            <SplideSlide>
              <CareerCard
                subtitle={card.subtitle}
                title={card.title}
                image={card.image}
                idx={idx}
              />
            </SplideSlide>
          ))}
        </SplideTrack>
      </Slider>
    </div>
  ) : null;
}

export default memo(CareerBlock);
